import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { graphql } from '@/gql'
import { user } from '@/composables/useUser'

/** Pre-selects the current user as client owner for MSP users the backend flags for it. */
export default function useDefaultClientOwnerFilter() {
  const { result, loading } = useQuery(
    graphql(`
      query DefaultClientOwnerFilter {
        defaultClientOwnerFilter
      }
    `),
    null,
    { clientId: 'publicApi' },
  )

  const clientOwners = computed<string[]>(() =>
    result.value?.defaultClientOwnerFilter ? [user.value.globalId] : [],
  )

  return { loading, clientOwners }
}
